module.exports = __webpack_public_path__ + "static/media/stress.6ef87fd7.svg";